import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ContentInput, Description, Title} from "./styled";

export default function Field(
    {
        title,
        description,
        colorDescription
    }: {
        title: string;
        description: string;
        colorDescription?: string;
    }
) {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <ContentInput>
            <Title color={colors.text}>{title}:&nbsp;</Title>
            <Description color={colorDescription ?? colors.text}>{description}</Description>
        </ContentInput>
    )
}